import { Box, Typography } from '@mui/material'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import CheckIcon from '@mui/icons-material/Check'
import ShelterIcon from '@mui/icons-material/NightShelterOutlined'

export interface AddressCardAddress {
  id: number
  address: string
  apartment: string
  city: string
  state: string
  zipCode: string
  isHomeless?: boolean
}

export interface AddressCardProps {
  address: AddressCardAddress
  isPrimary: boolean
  onSetPrimary: () => void
  onModify?: () => void
  onRemove?: () => void
}

export function AddressCard (props: AddressCardProps): JSX.Element {
  const { address } = props
  const isHomeless = address.isHomeless ?? false

  return (
    <Box sx={{ backgroundColor: '#ECEDEF', borderRadius: '10px', p: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
        {isHomeless ? <ShelterIcon sx={{ color: '#222024' }} /> : <PlaceOutlinedIcon sx={{ color: '#222024' }} />}
        <Box sx={{ flex: '1 0 0', minWidth: 0 }}>
          {props.isPrimary && (
            <Typography sx={{ fontWeight: 700, fontSize: '14px', color: '#222024' }}>Primary Residence</Typography>
          )}
          {isHomeless
            ? <Typography data-testid='homelessIndicator' sx={{ fontSize: '14px', color: '#222024' }}>Experiencing Homelessness</Typography>
            : <Typography sx={{ fontSize: '14px', color: '#222024' }}>{address.address}{(address.apartment ?? '') !== '' ? ` ${address.apartment}` : ''}</Typography>}
          <Typography sx={{ fontSize: '14px', color: '#222024' }}>{address.city}, {address.state}</Typography>
          <Typography sx={{ fontSize: '14px', color: '#222024' }}>{address.zipCode}</Typography>
        </Box>
        <Box
          data-testid={props.isPrimary ? 'primaryIndicator' : 'setPrimaryButton'}
          onClick={props.isPrimary ? undefined : props.onSetPrimary}
          sx={{
            width: '41px',
            height: '27px',
            borderRadius: '16px',
            backgroundColor: props.isPrimary ? '#02AED9' : 'transparent',
            border: props.isPrimary ? 'none' : '1px solid #969696',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: props.isPrimary ? 'default' : 'pointer',
            flexShrink: 0
          }}
        >
          {props.isPrimary && <CheckIcon sx={{ color: 'white', fontSize: '18px' }} />}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
        {props.onModify != null && (
          <Typography
            onClick={props.onModify}
            data-testid='modifyAddress'
            sx={{ fontSize: '16px', color: '#222024', textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }}
          >
            Modify Address
          </Typography>
        )}
        {!props.isPrimary && props.onRemove != null && (
          <Typography
            onClick={props.onRemove}
            data-testid='removeAddress'
            sx={{ fontSize: '16px', color: '#BC3656', textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }}
          >
            Remove
          </Typography>
        )}
      </Box>
    </Box>
  )
}
